import { PayloadAction } from '@reduxjs/toolkit';
import { QUOTE_LINE_INFO_TABS } from '@ui/config/price/constants';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { QuoteLineInternalType } from '../../types/state/quote-line';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { QuoteLineParams } from './types';

type ValidTabs =
  | typeof QUOTE_LINE_INFO_TABS.QUOTE_HISTORY
  | typeof QUOTE_LINE_INFO_TABS.ORDER_HISTORY;

type Params = QuoteLineParams & {
  tab: ValidTabs;
  customerOnly?: boolean;
};

const tabToStateVariableMap: Record<
  ValidTabs,
  keyof Pick<
    QuoteLineInternalType,
    | 'infoTabQuoteHistoryFilterByCustomer'
    | 'infoTabOrderHistoryFilterByCustomer'
  >
> = {
  [QUOTE_LINE_INFO_TABS.QUOTE_HISTORY]: 'infoTabQuoteHistoryFilterByCustomer',
  [QUOTE_LINE_INFO_TABS.ORDER_HISTORY]: 'infoTabOrderHistoryFilterByCustomer',
};

export function quoteLineInfoCustomerOnlyToggled(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<Params>,
) {
  const { customerOnly } = action.payload;

  const quoteLine = getQuoteLineOrThrow(state, action.payload.quoteLineUuid);

  if (customerOnly === undefined) {
    quoteLine[tabToStateVariableMap[action.payload.tab]] =
      !quoteLine[tabToStateVariableMap[action.payload.tab]];
  } else {
    quoteLine[tabToStateVariableMap[action.payload.tab]] = customerOnly;
  }
}
